

export const FETCH_VENDOR_MASTER_REQUEST = 'FETCH_VENDOR_MASTER_REQUEST';
export const FETCH_VENDOR_MASTER_SUCCESS = 'FETCH_VENDOR_MASTER_SUCCESS';
export const FETCH_VENDOR_MASTER_FAILURE = 'FETCH_VENDOR_MASTER_FAILURE';

export const FETCH_VENDOR_MASTER_BY_USER_REQUEST = 'FETCH_VENDOR_MASTER_BY_USER_REQUEST';
export const FETCH_VENDOR_MASTER_BY_USER_SUCCESS = 'FETCH_VENDOR_MASTER_BY_USER_SUCCESS';
export const FETCH_VENDOR_MASTER_BY_USER_FAILURE = 'FETCH_VENDOR_MASTER_BY_USER_FAILURE';



export const FETCH_SINGLE_VENDOR_MASTER_REQUEST = 'FETCH_SINGLE_VENDOR_MASTER_REQUEST';
export const FETCH_SINGLE_VENDOR_MASTER_SUCCESS = 'FETCH_SINGLE_VENDOR_MASTER_SUCCESS';
export const FETCH_SINGLE_VENDOR_MASTER_FAILURE = 'FETCH_SINGLE_VENDOR_MASTER_FAILURE';

export const CREATE_VENDOR_MASTER_FORM_MASTER = 'CREATE_VENDOR_MASTER_FORM_MASTER';


export const UPDATE_VENDOR_MASTER_REQUEST = 'UPDATE_VENDOR_MASTER_REQUEST';
export const UPDATE_VENDOR_MASTER_SUCCESS = 'UPDATE_VENDOR_MASTER_SUCCESS';
export const UPDATE_VENDOR_MASTER_FAILURE = 'UPDATE_VENDOR_MASTER_FAILURE';


export const DELETE_VENDOR_MASTER_REQUEST = 'DELETE_VENDOR_MASTER_REQUEST';
export const DELETE_VENDOR_MASTER_SUCCESS = 'DELETE_VENDOR_MASTER_SUCCESS';
export const DELETE_VENDOR_MASTER_FAILURE = 'DELETE_VENDOR_MASTER_FAILURE';


export const NAVIGATE_VENDOR_MASTER = 'NAVIGATE_VENDOR_MASTER';

export const REJECT_SINGLE_VENDOR_MASTER_REQUEST = 'REJECT_SINGLE_VENDOR_MASTER_REQUEST';
export const REJECT_SINGLE_VENDOR_MASTER_SUCCESS = 'REJECT_SINGLE_VENDOR_MASTER_SUCCESS';
export const REJECT_SINGLE_VENDOR_MASTER_FAILURE = 'REJECT_SINGLE_VENDOR_MASTER_FAILURE';


export const APPROVE_SINGLE_VENDOR_MASTER_REQUEST = 'APPROVE_SINGLE_VENDOR_MASTER_REQUEST';
export const APPROVE_SINGLE_VENDOR_MASTER_SUCCESS = 'APPROVE_SINGLE_VENDOR_MASTER_SUCCESS';
export const APPROVE_SINGLE_VENDOR_MASTER_FAILURE = 'APPROVE_SINGLE_VENDOR_MASTER_FAILURE';

export const APPROVE_VENDOR_MASTER_REQUEST = 'APPROVE_VENDOR_MASTER_REQUEST';
export const APPROVE_VENDOR_MASTER_SUCCESS = 'APPROVE_VENDOR_MASTER_SUCCESS';
export const APPROVE_VENDOR_MASTER_FAILURE = 'APPROVE_VENDOR_MASTER_FAILURE';

export const SET_PAN_FILE_NAME_VENDOR_MASTER = 'SET_PAN_FILE_NAME_VENDOR_MASTER';
export const SET_GST_FILE_NAME_VENDOR_MASTER = 'SET_GST_FILE_NAME_VENDOR_MASTER';


export const FILE_UPLOAD_DATA_VENDOR_GET_LIST_REQUEST = 'FILE_UPLOAD_DATA_VENDOR_GET_LIST_REQUEST';
export const FILE_UPLOAD_DATA_VENDOR_GET_LIST_SUCCESS = 'FILE_UPLOAD_DATA_VENDOR_GET_LIST_SUCCESS';
export const FILE_UPLOAD_DATA_VENDOR_GET_LIST_FAILURE = 'FILE_UPLOAD_DATA_VENDOR_GET_LIST_FAILURE';

export const FILE_UPLOAD_DATA_REQUEST = 'FILE_UPLOAD_DATA_REQUEST';
export const FILE_UPLOAD_DATA_SUCCESS = 'FILE_UPLOAD_DATA_SUCCESS';
export const FILE_UPLOAD_DATA_FAILURE = 'FILE_UPLOAD_DATA_FAILURE';

export const FETCH_PARTY_DETAILS_DATA_REQUEST = 'FETCH_PARTY_DETAILS_DATA_REQUEST';
export const FETCH_PARTY_DETAILS_DATA_SUCCESS = 'FETCH_PARTY_DETAILS_DATA_SUCCESS';
export const FETCH_PARTY_DETAILS_DATA_FAILURE = 'FETCH_PARTY_DETAILS_DATA_FAILURE';

export const FETCH_APPROVE_WITH_OUT_OVERWRITE_REQUEST = 'FETCH_APPROVE_WITH_OUT_OVERWRITE_REQUEST';
export const FETCH_APPROVE_WITH_OUT_OVERWRITE_SUCCESS = 'FETCH_APPROVE_WITH_OUT_OVERWRITE_SUCCESS';
export const FETCH_APPROVE_WITH_OUT_OVERWRITE_FAILURE = 'FETCH_APPROVE_WITH_OUT_OVERWRITE_FAILURE';

export const FETCH_APPROVE_WITH_OVERWRITE_REQUEST = 'FETCH_APPROVE_WITH_OVERWRITE_REQUEST';
export const FETCH_APPROVE_WITH_OVERWRITE_SUCCESS = 'FETCH_APPROVE_WITH_OVERWRITE_SUCCESS';
export const FETCH_APPROVE_WITH_OVERWRITE_FAILURE = 'FETCH_APPROVE_WITH_OVERWRITE_FAILURE';

export const VENDOR_APPROVAL_USERFORM_RESET = 'VENDOR_APPROVAL_USERFORM_RESET';

export const APPROVE_TOGGLE = 'APPROVE_TOGGLE';

export const UPDATE_UPLOAD_PREVIEW_IMG_REQUEST = 'UPDATE_UPLOAD_PREVIEW_IMG_REQUEST';
export const UPDATE_UPLOAD_PREVIEW_IMG_SUCCESS = 'UPDATE_UPLOAD_PREVIEW_IMG_SUCCESS';
export const UPDATE_UPLOAD_PREVIEW_IMG_FAILURE = 'UPDATE_UPLOAD_PREVIEW_IMG_FAILURE';

export const FETCH_PENDING_VENDOR_MASTER_REQUEST = 'FETCH_PENDING_VENDOR_MASTER_REQUEST';
export const FETCH_PENDING_VENDOR_MASTER_SUCCESS = 'FETCH_PENDING_VENDOR_MASTER_SUCCESS';
export const FETCH_PENDING_VENDOR_MASTER_FAILURE = 'FETCH_PENDING_VENDOR_MASTER_FAILURE';

export const FETCH_USER_HEADER_REQUEST = 'FETCH_USER_HEADER_REQUEST';
export const FETCH_USER_HEADER_SUCCESS = 'FETCH_USER_HEADER_SUCCESS';
export const FETCH_USER_HEADER_FAILURE = 'FETCH_USER_HEADER_FAILURE';